export class AsyncHandler {
  private static asyncErrorHandler: (e: Error) => void;

  /**
   * Register async-error handler
   * @param handler Error handler
   */
  public static registerAsyncErrorHandler(handler: (e: Error) => void): void {
    this.asyncErrorHandler = handler;
  }

  /**
   * Call async function
   * Be careful when function contains "this"
   */
  public static call(asyncFunc: () => Promise<any>, catchFunc?: (e: Error) => void): any {
    asyncFunc().catch((e: Error) => {
      /* istanbul ignore else */
      if (catchFunc) {
        catchFunc(e);
      } else if (this.asyncErrorHandler) {
        this.asyncErrorHandler(e);
      } else {
        throw e;
      }
    });
  }
}
